import React from 'react';

import { RegionAvailability } from 'models';

import { MultiSelectField, MultiSelectFieldProps } from 'components/forms/fields/MultiSelectField';

type RegionAvailabilityFieldProps = Omit<MultiSelectFieldProps, 'data'>;

const RegionAvailabilityField = (props: RegionAvailabilityFieldProps) => (
    <MultiSelectField {...props} data={RegionAvailability.options} />
);

export { RegionAvailabilityField };
